//------------------------------------------------------------------------------
// Wijmoヘルパー
//------------------------------------------------------------------------------
import { DataMap } from '@grapecity/wijmo.grid';
import { NBSP } from './pulldown-utils';

// 空の要素
export const EMPTY_DATA = {
  value: '',
  label: NBSP,
};

/**
 * データマップ作成
 *
 * @param {array} dataList データ配列
 *                (属性 value と label を持つオブジェクトの配列)
 */
export function makeDataMap(dataList) {

  // 空の要素を追加
  const withEmpty = Array.isArray(dataList)
    ? [ EMPTY_DATA, ...dataList ]
    : [ EMPTY_DATA ];

  // データマップ作製
  return new DataMap(withEmpty, 'value', 'label');
}

/**
 * データマップ変換
 *
 * @param {DataMap} データマップ
 * @return 属性 value と label を持つオブジェクトの配列
 */
export function mapValues(dataMap) {
  if (!dataMap) {
    return [ EMPTY_DATA ]; 
  }
  return dataMap.getKeyValues().map((key) => ({
    value: key,
    label: dataMap.getDisplayValue(key),
  }));
}

/**
 * 数値変換
 */
export function float(value) {
  const num = Number.parseFloat(value);  
  return Number.isNaN(num) ? null : num;
}

// デフォルトエクスポート
export default {
  makeDataMap,
  mapValues,
  float,
};
